import { User } from "@/CodegenTypes";

type DdCompanyLevelUser = Pick<User, "ddCompanyPl">;

export const canSeeDdCompanyLevel = (user?: DdCompanyLevelUser | null) => {
  return (user?.ddCompanyPl || 0) > 0;
};
